export default {
  '0101': {
    'title': '点检服务',
    'imgUrl': 'static/img/服务图片/点检.jpg',
    'content': '中控点检服务是指对DCS系统和SIS系统进行全面、深入的检测、保养和维护的服务。通过点检服务，能很大程度上提高系统可靠性、延长系统使用寿命、优化备品备件库存管理、降低系统综合维护费用。目前，中控已经在各行业进行过点检服务近万起。<br/>典型业绩如下：<br/>万华化学（宁波）氯碱有限公司<br/>中国石化集团南京化学工业有限公司<br/>湖北沙隆达股份有限公司、哈萨克斯坦LTD.石化有限责任公司、PT.South Pacific Viscose、中国石油化工股份有限公司石家庄炼化分公司、山西潞安环能煤焦化工有限责任公司、中国石油化工股份有限公司济南分公司<br/>中国石油天然气股份有限公司玉门油田分公司、中国石油化工股份有限公司天津分公司 '
  },
  '0102': {
    'title': '保修服务',
    'imgUrl': 'static/img/服务图片/保修服务.jpg',
    'content': '中控保修服务产品是在超出基本保修期后仍可以享受原保修期内相关权益的服务，即延长质保期。通过保修服务，可以降低现场DCS控制系统的维修成本、延长产品使用寿命、提升产品使用满意度。'
  },
  '0103': {
    'title': '备件服务',
    'imgUrl': 'static/img/服务图片/备件.jpg',
    'content': '为客户提供备件咨询、备件库支持、备件检测保养、备件销售、备件配置及备件相关现场服务。帮助企业用户最大程度地降低因备件问题而产生的停车风险。<br/><br/>适用范围：<br/>所有中控的系统产品用户。<br/><br/>服务内容：<br/>提供备件的咨询、配置和常规的现场服务。<br/><br/>服务收益：<br/>使用户获得备件供应保障，提高备件配置合理性。<br/><br/>典型用户：<br/>序号 公司名称 项目名称1 浙江恒盛生态能源有限公司 备品备件2 太仓中化环保化工有限公司 中化备件63 方大特钢科技股份有限公司 方大特钢服务4 马钢股份第一能源总厂 一能源09备件45 中海油气（泰州）有限公司 中海油气(泰州)石化服务'
  },
  '0104': {
    'title': '定制服务',
    'imgUrl': 'static/img/服务图片/定制服务.jpg',
    'content': '中控定制服务是根据用户个性化需求，专门设计并提供的服务项目，其特点为灵活、快速、定制化。<br/><br/>适用范围：<br/>所有中控的系统产品用户。<br/><br/>服务内容：<br/>需求整理、可行性分析；<br/>方案实施、样品测试；<br/>产品优化、批量生产；<br/>服务内容视项目特点及用户需求情况而定。<br/><br/>服务收益：<br/>更加适合本企业的生产装置，提高企业生产效益。'
  },
  '0105': {
    'title': '扩容服务',
    'imgUrl': 'static/img/服务图片/扩容服务.jpg',
    'content': '中控扩容服务是为更好地满足用户生产需求，在原系统规模基础上，帮助用户增加（新上项目）控制系统的服务产品。<br/><br/>适用范围：<br/>所有中控的系统产品用户。 <br/><br/>服务内容：<br/>主要包括案设计、系统软硬增减、组态修改调试、安装指导、系统上电、协助联调试运、操作培训等服务内容；<br/><br/>服务收益：<br/>扩容服务可以利用较少的资金和时间投入，完成系统使用能力的扩充，提高企业生产效益。'
  },
  '0106': {
    'title': '利旧服务',
    'imgUrl': 'static/img/服务图片/利旧改造.jpg',
    'content': '利旧改造服务是指由于随同装置搬迁或者应用在其它装置上的需要，针对将旧的中控DCS系统的全部或部分部件进行搬迁或利用改造的过程，由中控专业服务工程师综合资产评估利用、系统安全防护、搬迁保养更新、工程设计与实施等方面因素提供整体解决方案。<br/><br/>适用范围：<br/>存在原有系统再利用需求的中控DCS用户，如搬迁、异装置应用等情形；<br/>面向的系统型号：JX-300X、JX-300XP、ECS-100、ECS-700。<br/><br/>服务内容：<br/>系统整理与备份；专业的模块拆卸、包装、储运；系统部件性能测试；利旧分析与方案设计；系统清洁与恢复；易损易耗品更换；系统版本升级；系统组态常规修改；安装指导、现场调试投运；维保计划建议；半年保修；<br/><br/><br/>服务收益：<br/>闲置资产得到充分利用，降低企业投资成本；<br/>原有隐患得到排除，保证系统健康状态；<br/>防范搬迁等过程中产生新的隐患；<br/>合理的优化性升级及维护建议，延长系统使用寿命；<br/><br/>典型用户：<br/>截止目前，中控服务已为江苏恒盛化肥有限公司、江苏常隆化工有限公司、南通江山农药化工股份有限公司、福建三钢（集团）三明化工有限责任公司等数十家工业企业提供过利旧改造服务。'
  },
  '0107': {
    'title': '年保服务',
    'imgUrl': 'static/img/服务图片/年保服务.jpg',
    'content': '年保服务能够在指定期限内为用户提供快速的紧急保障、周期性的现场巡检及常规维护服务，包括能够为用户提供：定期现场巡检与常规维护；7*24小时紧急响应；紧急报修；配备专家小组等，并最终为系统稳定运行保驾护航。<br/>适用范围：<br/>年保服务主要针对使用中控的控制系统套数较多、人力资源紧缺或技术力量相对薄弱的用户。<br/><br/>服务内容：<br/>紧急现场服务、系统环境检查、系统运行状态及历史状态检查、安全隐患检查、组态常规修改与备份、故障处理、技术交流、为系统建立巡检档案。<br/><br/>服务收益：<br/>提高紧急事件处理效率，及时消除系统隐患，把握系统运行状态和变化情况，为系统长期稳定运行保驾护航。<br/><br/>典型用户：<br/>中控运维已为上海石化、燕山石化、印象西湖、龙盛化工、龙盛安诺、马钢、梅兰化工等数十家工业企业用户提供过控制系统巡检维护服务。'
  },
  '0108': {
    'title': '升级服务',
    'imgUrl': 'static/img/服务图片/升级.jpg',
    'content': '中控升级服务是指对已竣工项目系统的软、硬件进行升级的技术服务，以较少的投资提升系统品质。<br/><br/>适用范围：<br/>ECS-100、JX-300XP、ECS-700等系统中较老版本的系统；<br/><br/>服务内容：<br/>项目管理、方案设计、组态升级、安装指导、系统上电、协助联调试运、操作培训、文件资料编写等；<br/>服务内容可适当变化，具体视项目特点及用户需求情况而定。<br/><br/>服务收益：<br/>提升系统品质、延长系统使用寿命、提高生产效益；<br/><br/>典型用户：<br/>序号 公司名称 项目名称1 江苏淮河化工有限公司 淮化安全改造2 四平源翔自动化设备有限公司 黄龙食品糖车间升级3 盘锦辽河数码科技发展有限公司 辽河油田SAGD增加OPC4 济南利泽盟展自控设备有限公司 DCS升级项目5 浙江卫星丙烯酸制造有限公司 卫星丙烯酸二、三期扩容装置及一期点检升级服务6 禾欣可乐丽超纤皮（嘉兴）有限公司 禾欣可乐丽DCS系统软件升级7 杭州电化集团有限公司 树脂、氯醚树脂、异丁醚编程组态8 乳源东阳光电化厂8万吨/年双氧水工程及2.5万吨/年离子膜烧碱JX-300X系统升级项目9 云南铜业股份有限公司 硫酸分厂系统升级10 青岛经济技术开发区热电燃气总公司 服务器更换升级<br/>… …… ……'
  },
  '0109': {
    'title': '替换代升级服务',
    'imgUrl': 'static/img/服务图片/替换代升级.png',
    'content': '基于数十年的大型控制系统工程项目实施经验积累，运用SUPCON WebField控制系统最新技术与产品，对老旧、超期服役或者处于产品生命周期末端的现场控制系统进行整体的全面更换、升级的专项定制服务。<br/><br/>为客户提供：<br/>解决老旧系统维护成本高、故障率高、维护不及时等问题；<br/>协助完成老旧系统组态解读；<br/>充分利用原有电缆；<br/>专业化项目管理，满足项目工期要求；<br/>满足用户对控制系统新技术的要求。'
  },
  '0110': {
    'title': '维保服务',
    'imgUrl': 'static/img/服务图片/维保.jpg',
    'content': '驻厂维保主要针对DCS、PLC以及SIS等流程工业控制系统，由专业维保服务工程师常驻于用户现场，提供7*24小时不间断的设备巡检、日常维护保养、故障处理、备件管理、设备报表与分析等专业系统维护服务。帮助企业用户：<br/>保障生产 —— 避免因系统原因引起装置计划外停车；<br/>快速诊断 —— 诊断快速准确，使系统突发故障发生时损失降到最低;<br/> 控制成本 —— 合理控制系统运行及维护的支出；<br/>高效运营 —— 提升系统生命周期投资回报率。<br/><br/>中控运维一直为中石化北海炼化等大型工业企业长期提供驻厂维保服务，承担全厂几乎所有控制系统的维护工作，帮助企业用户安全稳定生产。多次获中石化颁发的“优秀供应商”称号。'
  },
  '0111': {
    'title': '组态优化服务',
    'imgUrl': 'static/img/服务图片/组态优化.jpg',
    'content': '中控组态优化服务是在用户生产主装置不变的情况下，利用对已验收项目控制系统中的组态做优化，从而改进应用效果、提升操作体验的改造服务。<br/>适用范围：<br/>所有中控的系统产品用户。<br/>服务内容：<br/>流程图美化及修改；控制程序简单修改；现场控制功能完善；组态解读及整理；服务内容可适当变化，具体视项目特点及用户需求情况而定。<br/>服务收益<br/>提高系统易用性，完善现场控制方案，增加企业生产效益。'
  },
  '0201': {
    'title': '现场仪表校验服务',
    'imgUrl': 'static/img/服务图片/现场仪表校验服务.JPG',
    'content': '通过一系列专业仪表器或官方认可的检测机构合作，对现场仪表中需要定期校验、校准、标定，甚至准确性检定等服务，为业主生产的稳定性提供保障。'
  },
  '0202': {
    'title': '分析仪器校验服务',
    'imgUrl': '',
    'content': '对现场使用中的分析仪定期检测、检验、标定，以确保各类分析仪输出数据的准确性。'
  },
  '0203': {
    'title': '仪器仪表运保服务',
    'imgUrl': 'static/img/服务图片/仪器仪表运保服务.jpg',
    'content': '通过投运初期陪伴业主完成对自控系统的学习、熟悉、了解，从而有效提升生产效率和安全性，并可在整个生产周期对仪表运行情况的监测，陪伴业主对生产过程中仪表的表现、故障、工艺参数等定期或随叫随到式的保运服务。'
  },
  '0301': {
    'title': '产品培训',
    'imgUrl': 'static/img/服务图片/产品培训.jpg',
    'content': '中控培训中心常年同步开设各种产品培训课程，主题涵盖涵盖“SUPCON”品牌所有系统产品，包括JX-300XP工程师组态培训、ECS-100工程师组态培训、ECS-700工程师组态培训、TCS-900产品技术培训、G3G5产品技术培训、PIMS信息化系统培训等课程。全年滚动开设近200个培训班次，每年为企业培训和培养技术员工及骨干3000多人次。'
  },
  '0302': {
    'title': '专题培训',
    'imgUrl': 'static/img/服务图片/专题培训.jpg',
    'content': '面向不同客户需求，科学设计各种实用的、专业的、热点的、尖端的、前沿的专题培训，为自动化从业人员完善知识结构、提升管理及技术等方面的综合能力提供学习交流的平台，使之对相应专题进行系统的学习，并且可针对各类专题问题掌握解决问题的思路、方法及应对措施，为企业培养培养进阶式的人才梯队。全年不定期开班，培训主题涵盖：DCS系统维护与故障排除专题培训、DCS控制策略组态与优化专题培训、系统集成及通讯互联专题技术培训、控制系统抗干扰及防雷专题技术培训、工业控制系统信息安全专题研讨班等。'
  },
  '0303': {
    'title': '定制培训',
    'imgUrl': '',
    'content': '为了最大限度给客户提供方便快捷的培训和发挥企业优势，形成了一套灵活的培训机制，可随时根据企业实际培训需求，为企业量身定做培训解决方案，使企业在时间、地点、内容、形式等各方面享受充分灵活带来的价值。先后成功实施了中核集团定制维护技能培训、中石化集团各类操作人员培训、中石化集团技能比武竞赛定制培训、中国电力集团热工技能竞赛定制培训、伊朗/巴基斯坦/泰国/伊拉克等国内外项目的定制培训组织策划及实施。'
  },
  '0304': {
    'title': '网络培训',
    'imgUrl': 'static/img/服务图片/网络培训.jpg',
    'content': '基于互联网的普遍应用，中控培训推出高效、便利的网络培训平台（爱培训平台  i-learning.supcon.com），形成了线下实体授课、线上网络移动课堂相结合的完整培训环。借助爱培训平台（i-learning.supcon.com) 开展的线上课程包含在线互动教学、课程视频点播等多种形式,把培训课堂搬到您的企业或家里，让您不出门即可享受专业的培训。自2018年12月平台上线至今，已有数千人注册登录并通过平台进行自我技能提升学习。'
  },
  '0305': {
    'title': '仿真培训',
    'imgUrl': 'static/img/服务图片/仿真培训.jpg',
    'content': '培训中心配有各系列的仿真器或虚拟控制器，可进行教学演示、实现复杂程序的调试与练习。还建有OTS（即操作员培训仿真系统）实验室，逼真地模拟工厂的开停车、正常运行和各种事故过程的现象和操作，帮助企业提高操作员的知识水平和技术水平、缩短工厂开停车时间，，延长装置连续生产时间，提高安全性。'
  },
  '0401': {
    'title': '仪控抗干扰咨询服务',
    'imgUrl': '',
    'content': '仪控设备的干扰：<br/>日常应用中仪控设备经常会因为：1）设备的设计选型；2）设备构造及性能；3）设备的布置及安装；4）设备电源及信号的连接；5）接地与屏蔽的处理；6）使用环境及周边设备的影响；7）设备的日常维护等各方面的因素，引起仪控设备轻者数据波动，重则系统失控甚至殃及整改装置的安全...<br/>抗干扰咨询服务的内容: <br/>针对用户仪控设备已经或可能会出现的上述各类干扰问题，提供相应的解决及预防方案。<br/> 相关业绩和案例：<br/>岭澳核电有限公司 <br/>三门核电有限公司 <br/>灵宝金源晨光有色矿冶有限公司  <br/>新能能源有限公司  '
  },
  '0402': {
    'title': '防雷咨询及设计服务',
    'imgUrl': '',
    'content': '中控防雷服务是指完善企业用户防雷措施，增强企业用户仪控设施的抗干扰能力。<br/><br/>适用范围：<br/>所有企业用户；<br/><br/>服务内容：<br/>为用户提供雷击风险评估，雷击事故分析，仪控系统防雷设计及施工，雷电防护咨询和培训，干扰源排查，仪控整体解决方案等业务。提升企业用户提升防雷及抗干扰能力。<br/><br/>服务收益：<br/>提升企业用户仪控设施防雷及抗干扰能力，保障企业用户稳定生产；<br/><br/>典型用户：<br/>序号 公司名称 项目名称1 中海油海南基地  化肥一部防雷改造设计2 中国联合工程公司 杭州市燃气（集团）有限公司西部LNG应急气源站建设工程防雷设计3 晋煤集团江苏恒盛化肥有限公司 一期尿素装置、合成装置的雷击风险评估、防雷工程设计和设备集成。4 中海石油化学股份有限公司80万吨甲醇装置雷电风险评估5 中国石油天然气股份有限公司长庆油田分公司  第二、第三采气场雷击风险评估6 岭东核电有限公司  岭澳二期GRE接地系统分析服务 '
  },
  '0403': {
    'title': '智能工厂咨询服务',
    'imgUrl': '',
    'content': '对流程行业企业智能工厂整体建设开展顶层规划咨询服务，为企业全面实施智能工厂建设项目提供顶层规划方案和实施指导。<br/><br/>适用范围：<br/>石化、化工、建材、造纸、冶金、电力等典型流程行业企业用户<br/><br/>服务内容：<br/>以帮助企业实现自动化、信息化、智能化生产运营为目标，咨询服务内容范围覆盖企业原材料供应、生产、销售、物流、库存、安全环保、决策运营等所有业务相关环节。通过深入理解分析企业的发展战略、业务特征和相关需求，并结合国内外行业先进技术发展趋势，提出业务流程优化建议及智能化建设总体目标；基于智能工厂总体目标，从业务蓝图分析、应用架构、数据架构和治理运维架构等方面对企业实现智能制造进行顶层设计；定义智能工厂建设项目，制定建设项目的实施策略和路线，编制具体建设内容实施计划和投资概算，有效地指导企业智能化建设工作的开展。<br/><br/>服务收益：<br/>通过智能工厂咨询服务，以较少额资金和时间投入，可以为企业明确智能工厂总体建设目标、建设内容、建设路径和总体概算，为下一步开展具体建设项目招标提供技术和管理依据。<br/><br/>典型用户：<br/>序号     公司名称     项目名称1     陕西延长石油集团有限公司炼化公司  智能工厂总体设计2     中海石油炼化公司有限责任公司惠州炼油分公司  二期工程信息化规划咨询3     新疆天业（集团）有限公司   信息化咨询及智能工厂咨询规划4     陕西金泰氯碱神木化工有限公司   智能工厂总体方案设计5     甘肃银光化学工业集团有限公司    “十三五”数字化工厂建设规划6     山东华鲁恒升化工股份有限公司     智能工厂总体规划'
  },
  '0404': {
    'title': '智慧园区咨询服务',
    'imgUrl': '',
    'content': '对工业园区管理运营单位（部门）实现园区智慧化管理运营开展顶层设计咨询服务，为全面实施“智慧园区”项目建设提供顶层设计方案和实施指导。<br/><br/>适用范围：<br/>各类工业园区，特别是涉及到危化品生产储运的石化、化工园区<br/><br/>服务内容：<br/> 以帮助工业园区实现绿色、安全、可持续发展的智慧化运营管理为目标，咨询服务范围覆盖园区日常安全监管、日常环保监管、事故应急救援指挥、园区生产服务、园区能效评估与监控等所有业务相关环节需求。通过深入理解分析园区的业务特征和相关需求，并结合最新数字化、智能化先进技术发展趋势，提出园区管控业务流程优化建议及智慧化建设总体目标；基于智慧园区总体目标，从业务模型分析、应用架构、数据集成平台架构和治理运维架构等方面对园区实现智慧化管控和服务进行顶层设计；定义建设项目，制定项目的实施策略、建设和运营模式，编制具体建设内容实施计划和投资概算，有效地指导园区智慧化建设工作的开展。<br/><br/>服务收益：<br/>通过智慧园区咨询服务，为园区管理部门明确智慧园区总体建设目标、项目建设和运营模式、建设内容、建设路径和总体概算，为下一步开展具体建设项目招标提供技术和管理依据。<br/><br/>典型用户：<br/>序号     园区名称     项目名称1       杭州湾精细化工园区   环境监测平台系统规划和建设2       杭州市高新区             环境在线监测与应急平台3       新安化工马目园区      智慧园区规划和建设4       淮安盐化新材料产业园    安环与应急一体化平台集成设计5       镇江江南化工园区        综合安全生产管理系统6       宁波LG甬兴化工园区    综合防灾系统设计'
  },
  '0405': {
    'title': '开车保运服务',
    'imgUrl': '',
    'content': '化工生产装置开车保运工作：<br/>1、检查及正确投运各类现场仪表，保证仪表运行正常，无误报和飘移，仪表引压导管、三阀组无渗漏现象，伴热良好。2、一次组件与控制阀门无渗漏积水和呆滞现象，仪表供气正常、转动机构灵活、润滑。3、检查控制室仪表、PLC、DCS、SIS、ITCC控制站各卡件工作正常4、检查仪表电源、UPS在规定范围内，报警、联锁运行正常。5、控制阀的阀体故障判断工作：在故障判断过程中，阀门的拆卸、抽芯检查等工作，包括起重等各种工具的准备、工种的配合；控制阀的附件（含过滤减压阀、电磁阀、阀门定位器、阀位变送及开关、全套气源和气路控制附件）故障判断，行程调校及更换及检修；6、负责大机组及各类机泵的配套仪表的故障判断、校验、更换、检修及拆装工作；自动调节回路的投运；联锁报警回路中一次元件的投运。7、 DCS、SIS、ITCC控制系统的控制器、I/O卡件、系统电源、系统通讯模块、辅助机柜（安全栅柜、继电器柜、辅助接线柜）内的故障判断、元件更换、检修工作，机柜间的照明、空调、清洁。'
  },
  '0501': {
    'title': '系统备件框架协议',
    'imgUrl': '',
    'content': '与长期合作或有意长期合作的业主签定备品仪表、系统备品备件的代采购框架协议，进而通过统一的代采购及中控自身的庞大用量及中控供应链的价格和速度优势，为客户提供更具性价比的备件服务。'
  },
  '0502': {
    'title': '仪控类代采购服务',
    'imgUrl': '',
    'content': '为客户提供仪控仪表的代采购业务，包括各类传感器、变送器、定制仪表和分析仪等。'
  },
  '0503': {
    'title': '电气类代采购服务',
    'imgUrl': '',
    'content': '为提供提供电气代采购服务，包括旧设备更换、维修、替代升级，电气图纸设计等。'
  }
}
